import React from 'react';
import {TableUnsendInvitations, TableFailedFooter, TableContainer} from './styles';
import LargeButton from '../largeButton/largeButton';

export default ({callback, failedInvitations}: {callback: any; failedInvitations: Array<any>}) => {
  function generateFailedInvitations(invitations: Array<any>) {
    const listOFInvitations = Array<any>([]);
    for (let i of invitations) {
      const invitationFail = (
        <tr key={i[2]}>
          <td>{i[0]}</td>
          <td>{i[1]}</td>
          <td>{i[2]}</td>
        </tr>
      );
      listOFInvitations.push(invitationFail);
    }
    return listOFInvitations;
  }
  return (
    <>
      <TableContainer>
        <TableUnsendInvitations>
          <thead>
            <tr>
              <th>FIRST NAME</th>
              <th>LAST NAME</th>
              <th>EMAIL</th>
            </tr>
          </thead>
          <tbody>{generateFailedInvitations(failedInvitations)}</tbody>
        </TableUnsendInvitations>
      </TableContainer>
      <TableFailedFooter>
        <LargeButton
          title="Close"
          callback={callback}
          rColor="#ffffff"
          lColor="#ffffff"
          fColor="#5D6C76"
          bColor="#F0F0F0"
          rMargin="0 40px"
          xMargin="25px 42px 25px 400px"
          fullWidth={false}
        />
      </TableFailedFooter>
    </>
  );
};
